import type { ReactNode } from 'react';
import AccessTime from '@mui/icons-material/AccessTime';
import AccountBox from '@mui/icons-material/AccountBoxOutlined';
import AccountTree from '@mui/icons-material/AccountTreeOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import CardTravel from '@mui/icons-material/CardTravel';
import ComputerRoundedIcon from '@mui/icons-material/ComputerRounded';
import Description from '@mui/icons-material/DescriptionOutlined';
import DuoOutlinedIcon from '@mui/icons-material/DuoOutlined';
import GraphicEq from '@mui/icons-material/GraphicEq';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import Language from '@mui/icons-material/Language';
import LiveTvRoundedIcon from '@mui/icons-material/LiveTvRounded';
import LocalLibrary from '@mui/icons-material/LocalLibraryOutlined';
import MenuBook from '@mui/icons-material/MenuBookOutlined';
import People from '@mui/icons-material/PeopleOutline';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import Public from '@mui/icons-material/Public';
import School from '@mui/icons-material/SchoolOutlined';
import { CourseTypes, ModalityTypes } from '@/models/catalog/course';
import { ResourceTypes } from '@/models/resources';

export const resourceIconMap = {
  AccessTime,
  AccountTree,
  CardTravel,
  Description,
  GraphicEq,
  LocalLibrary,
  MenuBook,
  People,
  PlayCircleOutline,
  Public,
  Language,
  School,
  AccountBox,
};

export type IconName = keyof typeof resourceIconMap;

const iconSize = 'small';

export const externalResourceIconNames: Record<ResourceTypes, IconName> = {
  [ResourceTypes.Book]: 'MenuBook',
  [ResourceTypes.Video]: 'PlayCircleOutline',
  [ResourceTypes.Document]: 'Description',
  [ResourceTypes.Course]: 'School',
  [ResourceTypes.EventOrLecture]: 'People',
  [ResourceTypes.Podcast]: 'GraphicEq',
  [ResourceTypes.Others]: 'Description',
};

export const courseTypeIconNames: Record<CourseTypes, IconName> = {
  [CourseTypes.Languages]: 'Language',
  [CourseTypes.NonDegree]: 'LocalLibrary',
  [CourseTypes.Postgraduate]: 'CardTravel',
  [CourseTypes.Technical]: 'AccountTree',
  [CourseTypes.Undergraduate]: 'School',
  [CourseTypes.Mentorship]: 'AccountBox',
};

export const modalityIconMap: Record<ModalityTypes, ReactNode> = {
  [ModalityTypes.Online]: <ComputerRoundedIcon fontSize={iconSize} />,
  [ModalityTypes.InPerson]: <ApartmentRoundedIcon fontSize={iconSize} />,
  [ModalityTypes.PrivateClass]: <DuoOutlinedIcon fontSize={iconSize} />,
  [ModalityTypes.LiveOnline]: <LiveTvRoundedIcon fontSize={iconSize} />,
  [ModalityTypes.Hybrid]: <HomeWorkRoundedIcon fontSize={iconSize} />,
};

export const courseTypeIconMap: Record<CourseTypes, ReactNode> = {
  [CourseTypes.Languages]: <Language fontSize={iconSize} />,
  [CourseTypes.NonDegree]: <LocalLibrary fontSize={iconSize} />,
  [CourseTypes.Postgraduate]: <CardTravel fontSize={iconSize} />,
  [CourseTypes.Technical]: <AccountTree fontSize={iconSize} />,
  [CourseTypes.Undergraduate]: <School fontSize={iconSize} />,
  [CourseTypes.Mentorship]: <AccountBox fontSize={iconSize} />,
};

export const externalResourceColors: Record<ResourceTypes, string> = {
  [ResourceTypes.Book]: 'warning.light',
  [ResourceTypes.Video]: 'error.light',
  [ResourceTypes.Document]: 'info.light',
  [ResourceTypes.Course]: 'primary.light',
  [ResourceTypes.EventOrLecture]: 'warning.light',
  [ResourceTypes.Podcast]: 'success.light',
  [ResourceTypes.Others]: 'success.light',
};
